export default __webpack_public_path__ + "static/media/Chandrashekaran.b0aef280.JPG";